import CommonResponseWithSteamPlayerPublicInfo from "../../models/CommonResponseWithSteamPlayerPublicInfo";
import axios from "axios";
import BackendClient from "../../BackendClient";

export function retrieveMySteamInfo(client: BackendClient): Promise<CommonResponseWithSteamPlayerPublicInfo> {
    const headers = {
      'Authorization': `${client.getAuthEntity()} ${client.getAuthToken()}`,
    };

    return new Promise<CommonResponseWithSteamPlayerPublicInfo>((resolve, reject) => {
      axios.get(`${client.getBackendUrl()}${BackendClient.RetrieveMySteamInfo}`, {headers: headers})
        .then((response) => resolve(response.data))
        .catch((reason) => {
          console.log(`Exception when trying to retrieve my steam info: ${JSON.stringify(reason)}`)
          reject(reason);
        });
    });
  }